import { render, staticRenderFns } from "./ChartStacked.vue?vue&type=template&id=604fa0ba&"
import script from "./ChartStacked.vue?vue&type=script&lang=js&"
export * from "./ChartStacked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604fa0ba')) {
      api.createRecord('604fa0ba', component.options)
    } else {
      api.reload('604fa0ba', component.options)
    }
    module.hot.accept("./ChartStacked.vue?vue&type=template&id=604fa0ba&", function () {
      api.rerender('604fa0ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/ChartStacked.vue"
export default component.exports